import PropTypes from "prop-types";
import {Navigate} from "react-router-dom";
import {hasRoleAccess} from "../../utils/roleUtils";
import {useRayzayUIController} from "../../context";
import LoadingSpinner from "../../components/LoadingSpinner";

const RoleBasedRoute = ({userRole, allowedRoles, children}) => {
    const [controller] = useRayzayUIController();
    const {isAuthenticated, loggedInUserDetail} = controller;

    console.log('RoleBasedRoute - State:', {
        isAuthenticated,
        userRole,
        allowedRoles,
        hasUserDetail: !!loggedInUserDetail
    });

    // Show loading if we're not authenticated yet or user details are still loading
    if (!isAuthenticated || loggedInUserDetail === null) {
        console.log('RoleBasedRoute - Showing loading (not authenticated or no user details)');
        return <LoadingSpinner message="Loading authentication..."/>;
    }

    // If user is authenticated but userRole is still undefined, wait for it to load
    if (isAuthenticated && (userRole === undefined || userRole === null)) {
        console.log('RoleBasedRoute - Showing loading (authenticated but role not loaded)');
        return <LoadingSpinner message="Loading user details..."/>;
    }

    // If user is authenticated and we have a role, check access
    if (!hasRoleAccess(userRole, allowedRoles)) {
        // Instead of redirecting to signin, redirect to dashboard since user is authenticated
        // but doesn't have permission for this specific route
        console.log(`RoleBasedRoute - Access denied: User with role ${userRole} does not have access to this route`);
        return <Navigate to="/dashboard"/>;
    }

    console.log('RoleBasedRoute - Access granted');
    return children;
};

RoleBasedRoute.propTypes = {
    userRole: PropTypes.string,
    allowedRoles: PropTypes.arrayOf(PropTypes.string),
    children: PropTypes.node
};

export default RoleBasedRoute;
